export default __webpack_public_path__ + "static/media/CN.49019317.svg";